import { Dispatch } from 'redux'

// Types
import { TDealerDetailUpdateState } from '@/types/store/state'
import { DEALER_DETAILS_UPDATE } from '@/types/store/const' 

export const setIsDealerUpdatingAddrAction: any =
(isUpdatingDealerAddress: TDealerDetailUpdateState) => (dispatch: Dispatch) => {
    dispatch({
      type: DEALER_DETAILS_UPDATE,
      payload: {
        isUpdatingDealerAddress
      },
    })
  }